export class ContactService {
  constructor(
    private readonly apiUrl: string,
  ) {}

  async getAllContacts() {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/gestionnaire/contacts`, {
        method: "GET",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération des contacts:", error);
      throw error;
    }
  }
}
